import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const tabItems = [
  { id: "dashboard", icon: "📊", label: "لوحة التحكم" },
  { id: "products", icon: "📦", label: "المنتجات" },
  { id: "categories", icon: "📁", label: "الفئات" },
  { id: "orders", icon: "📄", label: "الطلبات" },
  { id: "users", icon: "👥", label: "المستخدمين" },
];

const allMenuItems = [
  { id: "dashboard", icon: "📊", label: "لوحة التحكم", color: "bg-[#2B3649]" },
  { id: "products", icon: "📦", label: "المنتجات", color: "bg-[#D4C4B0]" },
  { id: "categories", icon: "📁", label: "الفئات", color: "bg-[#D4C4B0]" },
  { id: "orders", icon: "📄", label: "الطلبات", color: "bg-[#D4C4B0]" },
  { id: "users", icon: "👥", label: "المستخدمين", color: "bg-[#D4C4B0]" },
  { id: "settings", icon: "⚙️", label: "الإعدادات", color: "bg-[#D4C4B0]" },
  { id: "slider", icon: "🖼️", label: "الشرائح", color: "bg-[#D4C4B0]" },
  { id: "cities", icon: "🏙️", label: "المدن", color: "bg-[#D4C4B0]" },
  { id: "promo", icon: "🎟️", label: "الرموز الترويجية", color: "bg-[#D4C4B0]" },
];

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState("dashboard");
  const navigate = useNavigate();

  const renderContent = () => {
    switch (activeTab) {
      case "dashboard":
        return (
          <div className="p-4">
            {/* Desktop View - Show vertical menu */}
            <div className="hidden sm:block">
              <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">لوحة التحكم</h2>
              <div className="flex flex-col gap-4 max-w-md mx-auto">
                {allMenuItems.map((item, index) => (
                  <button
                    key={item.id}
                    onClick={() => setActiveTab(item.id)}
                    className={`${item.color} ${
                      index === 0 ? 'text-white' : 'text-gray-800'
                    } rounded-2xl p-6 flex items-center justify-between text-xl font-medium shadow-lg transition-all hover:scale-105`}
                  >
                    <span>{item.label}</span>
                    <span className="text-2xl">{item.icon}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Mobile View - Show statistics dashboard */}
            <div className="sm:hidden">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">لوحة التحكم</h2>
              
              {/* Statistics Cards */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-yellow-100 p-4 rounded-lg text-center">
                  <div className="text-2xl font-bold text-yellow-800">20</div>
                  <div className="text-sm text-yellow-600">المنتجات</div>
                  <div className="text-yellow-500">📦</div>
                </div>
                <div className="bg-blue-100 p-4 rounded-lg text-center">
                  <div className="text-2xl font-bold text-blue-800">7</div>
                  <div className="text-sm text-blue-600">الطلبات</div>
                  <div className="text-blue-500">📄</div>
                </div>
                <div className="bg-purple-100 p-4 rounded-lg text-center">
                  <div className="text-2xl font-bold text-purple-800">22</div>
                  <div className="text-sm text-purple-600">العملاء</div>
                  <div className="text-purple-500">👥</div>
                </div>
                <div className="bg-green-100 p-4 rounded-lg text-center">
                  <div className="text-2xl font-bold text-green-800">3</div>
                  <div className="text-sm text-green-600">الإداريين</div>
                  <div className="text-green-500">👨‍💼</div>
                </div>
              </div>

              {/* Revenue Card */}
              <div className="bg-green-50 p-4 rounded-lg text-center mb-6">
                <div className="text-sm text-green-600 mb-1">الإيرادات</div>
                <div className="text-3xl font-bold text-green-800">18 KD</div>
              </div>

              {/* Recent Products */}
              <div className="bg-white rounded-lg p-4 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">المنتجات الحديثة</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-orange-200 rounded-lg flex items-center justify-center">
                        <span className="text-orange-600">🍪</span>
                      </div>
                      <div>
                        <div className="font-medium">مسباح بكليت</div>
                        <div className="text-sm text-gray-500">منتج بكليت</div>
                      </div>
                    </div>
                    <div className="text-green-600 font-semibold">10 KD</div>
                  </div>
                  
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-yellow-200 rounded-lg flex items-center justify-center">
                        <span className="text-yellow-600">📿</span>
                      </div>
                      <div>
                        <div className="font-medium">مسباح جمالر</div>
                        <div className="text-sm text-gray-500">مسباح متوسط</div>
                      </div>
                    </div>
                    <div className="text-green-600 font-semibold">10 KD</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case "products":
        return (
          <div className="p-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">المنتجات</h2>
            <div className="space-y-4">
              <button 
                onClick={() => navigate('/admin/products/new')}
                className="w-full bg-green-500 text-white p-4 rounded-lg font-medium hover:bg-green-600 transition-colors"
              >
                إضافة منتج جديد
              </button>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 text-center">قائمة المنتجات ستظهر هنا</p>
                <button 
                  onClick={() => navigate('/admin/products')}
                  className="mt-2 w-full bg-blue-500 text-white p-2 rounded-lg text-sm hover:bg-blue-600 transition-colors"
                >
                  عرض جميع المنتجات
                </button>
              </div>
            </div>
          </div>
        );
      case "categories":
        return (
          <div className="p-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">الفئات</h2>
            <div className="space-y-4">
              <button className="w-full bg-yellow-500 text-white p-4 rounded-lg font-medium">
                إضافة فئة جديدة
              </button>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 text-center">قائمة الفئات ستظهر هنا</p>
              </div>
            </div>
          </div>
        );
      case "orders":
        return (
          <div className="p-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">الطلبات</h2>
            <div className="space-y-4">
              <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
                <h3 className="font-semibold text-yellow-800">طلبات في الانتظار</h3>
                <p className="text-yellow-600">5 طلبات</p>
              </div>
              <div className="bg-green-50 border border-green-200 p-4 rounded-lg">
                <h3 className="font-semibold text-green-800">طلبات مكتملة</h3>
                <p className="text-green-600">23 طلب</p>
              </div>
            </div>
          </div>
        );
      case "users":
        return (
          <div className="p-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">المستخدمين</h2>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg text-center">
                  <h3 className="font-semibold text-blue-800">العملاء</h3>
                  <p className="text-2xl font-bold text-blue-600">156</p>
                </div>
                <div className="bg-purple-50 border border-purple-200 p-4 rounded-lg text-center">
                  <h3 className="font-semibold text-purple-800">الإداريين</h3>
                  <p className="text-2xl font-bold text-purple-600">3</p>
                </div>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div className="p-4">
            <p className="text-center text-gray-500">المحتوى غير متوفر</p>
          </div>
        );
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Main Content - Always visible */}
      <div className="pb-20 sm:pb-0">
        {renderContent()}
      </div>

      {/* Bottom Navigation - Mobile Only */}
      <div className="sm:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
        <div className="flex justify-around items-center py-2 px-1">
          {tabItems.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex flex-col items-center justify-center p-2 rounded-lg transition-all min-w-0 flex-1 ${
                activeTab === tab.id
                  ? "bg-blue-100 text-blue-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              <span className="text-lg mb-1">{tab.icon}</span>
              <span className="text-xs font-medium text-center leading-tight">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
